export const SUPPORT_ALL = 'SUPPORT_ALL';
export const SUPPORT_ALL_SUCCESS = 'SUPPORT_ALL_SUCCESS';
export const SUPPORT_GET = 'SUPPORT_GET';
export const SUPPORT_GET_SUCCESS = 'SUPPORT_GET_SUCCESS';
export const SUPPORT_CREATE = 'SUPPORT_CREATE';
export const SUPPORT_CREATE_SUCCESS = 'SUPPORT_CREATE_SUCCESS';
export const SUPPORT_RESOLVE = 'SUPPORT_RESOLVE';
export const SUPPORT_RESOLVE_SUCCESS = 'SUPPORT_RESOLVE_SUCCESS';
export const SUPPORT_COMMENT = 'SUPPORT_COMMENT';
export const SUPPORT_COMMENT_SUCCESS = 'SUPPORT_COMMENT_SUCCESS';
export const SUPPORT_ADD_ATTACHMENT = 'SUPPORT_ADD_ATTACHMENT';
export const SUPPORT_ADD_ATTACHMENT_SUCCESS = 'SUPPORT_ADD_ATTACHMENT_SUCCESS';
export const SUPPORT_GET_ATTACHMENT = 'SUPPORT_GET_ATTACHMENT';
export const SUPPORT_GET_ATTACHMENT_SUCCESS = 'SUPPORT_GET_ATTACHMENT_SUCCESS';
